export default "__VITE_ASSET__DDsgSTIY__"